/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import { GetAlertSeverityAdAlertFragmentDoc } from '../../../../alerts-common/src/lib/utils/getAlertSeverity.hook'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type AdVehicleStreamAdAlertListVehicleFragment = {
  __typename?: 'Vehicle'
  fccOperatorAdAlerts: {
    __typename?: 'FccAdAlerts'
    alerts: Array<{
      __typename: 'FccAdAlert'
      id: string
      createdAt: string
      type: Types.FccAdAlertType
      status: Types.FccAdAlertStatus
    }>
  } | null
}

export type AdVehicleStreamAdAlertListAdAlertFragment = {
  __typename: 'FccAdAlert'
  id: string
  createdAt: string
  type: Types.FccAdAlertType
  status: Types.FccAdAlertStatus
}

export const AdVehicleStreamAdAlertListAdAlertFragmentDoc = gql`
    fragment AdVehicleStreamAdAlertListAdAlert on FccAdAlert {
  __typename
  id
  createdAt
  type
  status
  ...GetAlertSeverityAdAlert
}
    ${GetAlertSeverityAdAlertFragmentDoc}`
export const AdVehicleStreamAdAlertListVehicleFragmentDoc = gql`
    fragment AdVehicleStreamAdAlertListVehicle on Vehicle {
  fccOperatorAdAlerts {
    alerts {
      ...AdVehicleStreamAdAlertListAdAlert
    }
  }
}
    ${AdVehicleStreamAdAlertListAdAlertFragmentDoc}`
